<template>
  <b-card>
    <div slot="header">
      <h4 class="mr-5 pull-left">{{$t('USERS')}}</h4>
      <new-button
                  @click="newUser"
                   button_type="new" variant="primary" class="pull-right">
          {{$t('NEW')}}
      </new-button>
    </div>
    <user-aside   v-model="userEditAsidePanelState" v-on:closeAside="closePanel">
      <template slot="header">
        <template v-if="formNewUser">
          Novi korisnik
        </template>
        <template v-else>
          Uredi korisnika
        </template>

      </template>
      <user-edit-form v-if="formUpdateUser" @closePanel="closePanel" :id="id"></user-edit-form>
      <user-new-form v-else-if="formNewUser" @closePanel="closePanel"></user-new-form>
    </user-aside>
    <form class="mb-4" @submit.prevent="search" @reset.prevent="resetForm">
      <b-row>
        <b-col md="2" class="">
          <label class="label-text">Ime i prezime</label>
          <b-input  v-model="name" type="text"></b-input>
        </b-col>
        <b-col md="2" class="">
          <label class="label-text">Email</label>
          <b-input  v-model="email" type="text"></b-input>
        </b-col>
        <b-col md="3" class="">
          <label class="label-text">Klijent</label>
          <search-client v-model="clientSearch"/>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="d-inline-flex">
          <app-submit :disabled="loading" :loading="loader_submit" class="mr-3" variant="primary"  button_type="search"> {{$t('SEARCH')}}</app-submit>
          <app-submit :disabled="loading" :loading="loader_reset" class="mr-3" variant="outline-primary" type="reset" button_type="reset">{{$t('RESET')}}</app-submit>
        </b-col>
      </b-row>
    </form>
    <div class="table-responsive">
      <table class="table hover">
        <thead>
        <tr>
          <th>Ime i prezime</th>
          <th>{{$t('EMAIL')}}</th>
          <th>Klijenti</th>
          <th>Uloga</th>
          <th>{{$t('STATUS')}}</th>
          <th></th>

        </tr>
        </thead>
        <tbody>
        <tr :key="`user_${index}`" v-for="(user,index) in userList">
          <td>{{user.name}}</td>
          <td>{{user.email}}</td>
          <td>
            <div :key="client.id" v-for="client in user.clients">
              <span :style="client.default && user.clients.length > 1 ? 'font-weight: 600' : ''">{{client.name}}</span>
            </div>
          </td>
          <td>{{user.role.name}}</td>
          <td>{{user.hasOwnProperty('is_active') && Number(user.is_active) === 1 ? $t('ACTIVE') : $t('NOTACTIVE') }}</td>
          <td width="1rem">
             <user-edit-button
                    @click="edit(user.id)">
             </user-edit-button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <b-pagination
      size="sm"
      :prev-text="$t('PREV')"
      :next-text="$t('NEXT')"
      :total-rows="listCount"
      :per-page="perPage"
      v-model="currentPage">
    </b-pagination>
  </b-card>
</template>

<script>
  import UserEditButton from '@/components/app/AppEdit'
  import UserAside from '@/components/app/form/AppAside'
  import NewButton from '@/components/app/AppButton'
  import UserEditForm from '@/components/user/UserEditForm'
  import UserNewForm from '@/components/user/UserNewForm'
  import {getUserList} from '@/services/user/index'
  import SearchClient from "@/components/client/SearchClient";
  import AppSubmit from "@/components/app/AppSubmit";

  export default {
    name: "index",
    data(){
      return {
        fields: [
          {key: 'first_name', label: this.$t('FIRST_NAME')},
          {key: 'last_name', label: this.$t('LAST_NAME')},
          {key: 'email', label: this.$t('EMAIL')},
          {key: 'edit', label: this.$t('EDIT')}
        ],
        userEditAsidePanelState:false,
        formNewUser:false,
        formUpdateUser:false,
        id:null,
        clientSearch: {
          id: null,
          name: null
        },
        loader_submit: false,
        loader_reset: false,
        loading: false
      }
    },
    components:{
      AppSubmit,
      SearchClient,
      NewButton,
      UserAside,
      UserEditButton,
      UserEditForm,
      UserNewForm
    },
    computed:{
      filter() {
        return this.$store.getters['user/getSearchFilter']
      },
      currentPage: {
        get() {
          return this.filter.page
        },
        set(value) {
          this.$store.commit('user/setSearchFilterItem', {item: 'page', value})
          this.$store.dispatch('user/actionSearch')
        },
      },
      name: {
        get() {
          return this.filter.name;
        },
        set(value) {
          this.$store.commit('user/setSearchFilterItem', {item: 'name', value})
        }
      },
      email: {
        get() {
          return this.filter.email;
        },
        set(value) {
          this.$store.commit('user/setSearchFilterItem', {item: 'email', value})
        }
      },
      listCount(){
        return this.$store.getters['user/getSearchListCount']
      },
      userList(){
        return this.$store.getters['user/getSearchList']
      },
      perPage() {
        return this.filter.limit
      },
    },
    methods: {
      closePanel(){
        this.id = null
        this.userEditAsidePanelState = false
        this.formUpdateUser = false
        this.formNewUser = false

      },
      edit(id) {
        this.id = id
        this.userEditAsidePanelState = true
        this.formUpdateUser = true
        this.formNewUser = false;
      },
      newUser() {
        this.userEditAsidePanelState = true
        this.formNewUser = true
        this.formUpdateUser = false;
      },
     async search(mode = 'search') {
        if(this.clientSearch && this.clientSearch.id) {
          this.$store.commit('user/setSearchFilterItem', {item: 'client_id', value: this.clientSearch.id})
        }
        this.loading = true;
       if (mode === 'search') {
         this.loader_submit = true
       } else if(mode === 'reset') {
         this.loader_reset = true;
       }

        await this.$store.dispatch('user/actionSearch')
       if (mode === 'search') {
         this.loader_submit = false
       } else if(mode === 'reset') {
         this.loader_reset = false;
       }
       this.loading = false
      },
      resetForm() {
        this.clientSearch = {id: null, name: null}
        this.$store.commit('user/setSearchFilterItem', {item: 'name', value: null})
        this.$store.commit('user/setSearchFilterItem', {item: 'email', value: null})
        this.$store.commit('user/setSearchFilterItem', {item: 'client_id', value: null})
        this.search('reset')
      }

    },
    async mounted(){
      await this.search('mount')
    },
    watch: {
      currentPage: {
        handler() {
          this.search();
        }
      }
    }
  }
</script>

<style scoped>

</style>
